import Template from './Source.hbs';
import Button from 'views/components/wysiwyg/parts/buttons/Button';

export default class Source extends Button {

    // TinyMCE command as default or defined in wysiwyg.js
    command = 'ToggleShowSource'

    // Initialize function for initializing button specific logic
    initializeButton() {

        // Set the icon to the template
        this.icon = Template();

        // Set the tooltip to a translated string
        this.tooltip = window.i18n.gettext('View source');
    }

}
